import React from 'react'
import { checkTranslation, translate } from '../../utils/useful'
import StagesManager from '../../components/StagesManager'
import OwnedRooms from './OwnedRooms'
import OtherRooms from './OthersRooms'
import RoomsInfo from './RoomsInfo'
import HttpServices from '../../utils/Http.services'


class YourRooms extends React.Component {
    state = {

        isLoader: false,
        currentPage: 'owned',
        currentRoom: {},

        videocalls: [
            // { icon: "/assets/icons/rooms/rejected.svg", color: "#FF3B30", name: "Class 101", creator: "Pouya Pezhman", date: "Today, 9:55 AM" },
            // { icon: "/assets/icons/rooms/roomcall-gray.svg", color: "#444", name: "React Native class 234", creator: "Pouya Pezhman", date: "Yesterday, 5:25 PM" },
            // { icon: "/assets/icons/rooms/roomcall-gray.svg", color: "#444", name: "Math Elemntry 209", creator: "Pouya Pezhman", date: "3/5/23, 10:55 AM" },
            // { icon: "/assets/icons/rooms/roomcall-gray.svg", color: "#444", name: "React Native class 234", creator: "Pouya Pezhman", date: "Yesterday, 5:25 PM" },
            // { icon: "/assets/icons/rooms/roomcall-gray.svg", color: "#444", name: "Math Elemntry 209", creator: "Pouya Pezhman", date: "3/5/23, 10:55 AM" },
            // { icon: "/assets/icons/rooms/roomcall-gray.svg", color: "#444", name: "React Native class 234", creator: "Pouya Pezhman", date: "Yesterday, 5:25 PM" },
            // { icon: "/assets/icons/rooms/roomcall-gray.svg", color: "#444", name: "Math Elemntry 209", creator: "Pouya Pezhman", date: "3/5/23, 10:55 AM" },
            // { icon: "/assets/icons/rooms/roomcall-gray.svg", color: "#444", name: "React Native class 234", creator: "Pouya Pezhman", date: "Yesterday, 5:25 PM" },
            // { icon: "/assets/icons/rooms/roomcall-gray.svg", color: "#444", name: "Math Elemntry 209", creator: "Pouya Pezhman", date: "3/5/23, 10:55 AM" },
            // { icon: "/assets/icons/rooms/roomcall-gray.svg", color: "#444", name: "React Native class 234", creator: "Pouya Pezhman", date: "Yesterday, 5:25 PM" },
            // { icon: "/assets/icons/rooms/roomcall-gray.svg", color: "#444", name: "Math Elemntry 209", creator: "Pouya Pezhman", date: "3/5/23, 10:55 AM" },
            // { icon: "/assets/icons/rooms/roomcall-gray.svg", color: "#444", name: "React Native class 234", creator: "Pouya Pezhman", date: "Yesterday, 5:25 PM" },
            // { icon: "/assets/icons/rooms/roomcall-gray.svg", color: "#444", name: "Math Elemntry 209", creator: "Pouya Pezhman", date: "3/5/23, 10:55 AM" },
            // { icon: "/assets/icons/rooms/roomcall-gray.svg", color: "#444", name: "React Native class 234", creator: "Pouya Pezhman", date: "Yesterday, 5:25 PM" },
            // { icon: "/assets/icons/rooms/roomcall-gray.svg", color: "#444", name: "Math Elemntry 209", creator: "Pouya Pezhman", date: "3/5/23, 10:55 AM" },
            // { icon: "/assets/icons/rooms/roomcall-gray.svg", color: "#444", name: "React Native class 234", creator: "Pouya Pezhman", date: "Yesterday, 5:25 PM" },
            // { icon: "/assets/icons/rooms/roomcall-gray.svg", color: "#444", name: "Math Elemntry 209", creator: "Pouya Pezhman", date: "3/5/23, 10:55 AM" },
        ],

        tabs: [
            { key: "owned", name: "{{lang}}rooms.Created by you", icon: "/assets/icons/rooms/brain.svg" },
            { key: "others", name: "{{lang}}rooms.Created by others", icon: "/assets/icons/rooms/brain.head.profile.svg" },
            // { key: "info", name: "info", icon: "/assets/icons/rooms/roomcall.svg" },
        ]
    }

    componentDidMount() {

        HttpServices.request('getMyRooms', { frame: this.props.page?._id, applet: this.props.applet?._id }, (fetchResult, fetchError) => {
            if (fetchError) {
                return
            }
            this.setState({ videocalls: fetchResult.info })

        })

    }

    componentWillUnmount() {
    }
    setData = (key, value, reference, cb) => {
        if (reference == 'RoomsHome') {
            this.setState({ [key]: value }, () => {
                if (cb) {
                    cb()
                }
            })
        }
        else {
            if (this.props.setData) {
                this.props.setData(key, value, reference, () => {
                })
            }
        }
    }


    changePage = (prop) => {
        this.setState({ currentPage: prop.key }, () => {
            // console.log('this.state.currentPage', this.state.currentPage)
        })
        this.stageManager.changeStage(prop.key)
    }




    render() {
        return (
            <div className='window-content-radius scroll-no-scrollbar h-100' style={{}}>
                {/* <div className=' w-100'> */}
                    <div className='position-sticky shadow-2' style={{ top: 0, backgroundColor: '#f6f6f6', zIndex: 2 }}>
                        {this.state.currentPage != 'info' ? (
                            <div>
                                <div className='px-4 pt-3 mb-2'>
                                    <div className="br-10" style={{ backgroundColor: '#fff' }}>
                                        <input className="py-2 px-2 w-100 change-placeHolder" value={this.state.listSearch} onChange={(e) => this.searchHub(e)} placeholder={translate('rooms.Search')} style={{ backgroundColor: 'transparent', border: 'none', color: "#444" }} />
                                    </div>
                                </div>
                                <div className=' py-2 px-4 position-sticky h-100 w-100' style={{ top: 10 }}>
                                    <div className='w-100 flexcc w-100'>
                                        <div className='flexcc w-100 tab-purple-btn br-10'>
                                            {this.state.tabs.map((prop, index) => {
                                                return (
                                                    <button key={index} className={'flexcc w-100 py-1 br-8 ' + (this.state.currentPage == prop.key ? ' selected m-1 ' : ' unselected m-1 ')} onClick={() => this.changePage(prop)}>
                                                        <img className='mrd-2' src={prop.icon} />
                                                        <p className='prd-3'>{checkTranslation(prop.name)}</p>
                                                    </button>
                                                )
                                            })}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div className='px-4 pt-3 mb-2' style={{ zIndex: 1 }}>
                                <div className='flexcb w-100 pb-3' style={{ borderBottom: "1px solid #eee" }}>
                                    <button className='flexc back-purple prd-3 pld-1 py-1 br-10' onClick={() => this.changePage({ key: 'owned' })}>
                                        <img width={22} src='/assets/icons/arrow-left-purple.svg' className='rtl-button' />
                                        <p className='weight-500'>{translate('rooms.Back')}</p>
                                    </button>
                                    <div className='br-10' style={{ backgroundColor: "#fff" }}>
                                        <p className='px-3 py-2 font-size-12' style={{ color: "#7064FE" }}>{translate('rooms.Rooms Information')}</p>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                    <div className='my-3 px-4'>
                        <StagesManager ref={el => this.stageManager = el} height={'100%'}>
                            <OwnedRooms setData={this.setData} showDate={this.props.showDate} changePage={this.changePage} videocalls={this.state.videocalls} width={this.props.width} isLoading={this.props.isLoading} stage={0} stageName={'owned'} />
                            <OtherRooms setData={this.setData} showDate={this.props.showDate} changePage={this.changePage} width={this.props.width} isLoading={this.props.isLoading} stage={1} stageName={'others'} />
                            <RoomsInfo setData={this.setData} currentRoom={this.state.currentRoom} showDate={this.props.showDate} changePage={this.changePage} stageManager={this.props.stageManager} width={this.props.width} isLoading={this.props.isLoading} currentPage={this.state.currentPage} language={this.props.language} stage={1} stageName={'info'} />
                        </StagesManager>
                    </div>
                {/* </div> */}
            </div>
        )
    }
}

export default YourRooms;